// JavaScript para manejar la funcionalidad de los filtros de colección

document.addEventListener('DOMContentLoaded', function() {
  // Función para manejar los toggles de los filtros
  function setupFilterToggles() {
    const toggleButtons = document.querySelectorAll('.collection__filter-toggle');
    
    toggleButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const filterId = this.getAttribute('data-target');
        const filterOptions = document.getElementById(filterId);
        
        // Toggle de la clase collapsed
        if (filterOptions.classList.contains('collapsed')) {
          filterOptions.classList.remove('collapsed');
          this.querySelector('.collection__filter-toggle-icon').textContent = '-';
        } else {
          filterOptions.classList.add('collapsed');
          this.querySelector('.collection__filter-toggle-icon').textContent = '+';
        }
      });
    });
  }
  
  // Función para manejar la selección de filtros y aplicación automática
  function setupFilterSelection() {
    const filterRadios = document.querySelectorAll('.collection__filter-radio');
    
    filterRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        // Aplicar estado visual activo
        const filterName = this.name;
        const filterValue = this.value;
        
        // Opcional: Desactivar otros radios del mismo grupo
        document.querySelectorAll(`input[name="${filterName}"]`).forEach(input => {
          const label = input.nextElementSibling;
          if (input.checked) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
        });
        
        // Aplicar filtro automáticamente (redirigir o enviar formulario)
        applyFilter(filterName, filterValue);
      });
    });
  }
  
  // Función para aplicar el filtro seleccionado
  function applyFilter(name, value) {
    // Obtener la URL actual
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    
    // Mantener el parámetro de ordenamiento actual si existe
    const sortBy = params.get('sort_by');
    
    // Limpiar todos los parámetros anteriores y establecer solo los necesarios
    params = new URLSearchParams();
    
    // Aplicamos el filtro normalmente para todos los tipos
    if (value !== '') {
      params.set(name, value);
    }
    
    // Mantener el ordenamiento
    if (sortBy) {
      params.set('sort_by', sortBy);
    }
    
    // Actualizar la URL y recargar la página
    url.search = params.toString();
    window.location.href = url.toString();
  }
  
  // Función para limpiar todos los filtros
  function setupClearFilters() {
    const clearButton = document.querySelector('.collection__filter-clear');
    if (clearButton) {
      clearButton.addEventListener('click', function(event) {
        event.preventDefault();
        
        // Eliminar todos los parámetros de filtro y mantener solo el ordenamiento
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const sortBy = params.get('sort_by');
        
        // Crear nuevos params solo con ordenamiento si existe
        const newParams = new URLSearchParams();
        if (sortBy) {
          newParams.set('sort_by', sortBy);
        }
        
        // Actualizar URL y recargar página
        url.search = newParams.toString();
        window.location.href = url.toString();
      });
    }
  }
  
  // Función para manejar el cambio de ordenamiento
  function setupSortBy() {
    const sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.href;
      });
    }
  }

  // Inicializar funcionalidad de filtros
  function initFilters() {
    setupFilterToggles();
    setupFilterSelection();
    setupClearFilters();
    setupSortBy();
    
    // Marcar visualmente los filtros ya seleccionados
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    
    // Para cada tipo de filtro, verificar si está activo
    ['filter_vendor', 'filter_type', 'filter_tag'].forEach(filterName => {
      const value = params.get(filterName);
      if (value) {
        const input = document.querySelector(`input[name="${filterName}"][value="${value}"]`);
        if (input) {
          input.checked = true;
          const label = input.nextElementSibling;
          label.classList.add('active');
        }
      }
    });
  }
  
  // Iniciar cuando el DOM esté listo
  initFilters();
});
